import { NgModule,CUSTOM_ELEMENTS_SCHEMA  } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PagesRoutingModule } from "./pages-routing.module";
import { SharedModule } from "../shared/shared.module";
import { PagesCoreComponent } from "./pages-core/pages-core.component";
import { LeftPanelComponent } from "./common/left-panel/left-panel.component";
import { RightPanelComponent } from "./common/right-panel/right-panel.component";
import { HeaderComponent } from "./common/header/header.component";
import { ContentSectionComponent } from "./content-section/content-section.component";

import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ForcedDirectedGraphComponent } from "./components/comp/forcedDirected/forcedDirected.component";
// import { PieChartComponent } from "./components/comp/pieChart/pieChart.component";
import { LineChartComponent } from "./components/comp/line-chart/line-chart.component";
import { MapChartComponent } from "./components/comp/map-chart/map-chart.component";
import { BarChartComponent } from "./components/comp/bar-chart/bar-chart.component";
import { RaceChartComponent } from "./components/comp/race-chart/race-chart.component";
import { DonutChartComponent } from "./components/comp/donut-chart/donut-chart.component";
import { SemiCircleChartComponent } from "./components/comp/semi-circle-chart/semi-circle-chart.component";
import { ScatterChartComponent } from "./components/comp/scatter-chart/scatter-chart.component";
import { GuageChartComponent } from "./components/comp/guage-chart/guage-chart.component";
import { HighchartPieComponent } from "./components/highCharts-comp/highchart-pie/highchart-pie.component";
// import { HighchartsChartModule } from "highcharts-angular";
import { APIService } from "./APIService";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from "ngx-pagination";
import { FilterPipe } from 'src/filter.pipe';
import { FormatPipe } from 'src/format.pipe';
import { NgxSpinnerModule } from "ngx-bootstrap-spinner";
import { OrderModule } from 'ngx-order-pipe';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [
    PagesCoreComponent,
    LeftPanelComponent,
    RightPanelComponent,
    HeaderComponent,
    ContentSectionComponent,
    DashboardComponent,
    ForcedDirectedGraphComponent,
    // PieChartComponent,
    LineChartComponent,
    MapChartComponent,
    BarChartComponent,
    RaceChartComponent,
    DonutChartComponent,
    SemiCircleChartComponent,
    ScatterChartComponent,
    GuageChartComponent,
    HighchartPieComponent,
    FilterPipe,
    FormatPipe
    
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    TooltipModule.forRoot(),
    // HighchartsChartModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    OrderModule
    // ToastrModule.forRoot()
  ],
  exports: [FilterPipe,FormatPipe],
  providers: [APIService],
})
export class PagesModule {}
